import React, { useEffect, useId, useRef, useState } from "react";

// Кнопка «?» в правом верхнем углу карточки: по нажатию — описание простым языком.
// Закрывается повторным нажатием, кнопкой «Понятно», Esc или кликом мимо.
export default function HelpBubble({ title, children }) {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const panelId = useId();

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (event) => {
            if (event.key === "Escape") setOpen(false);
        };
        const onClick = (event) => {
            if (rootRef.current && !rootRef.current.contains(event.target)) setOpen(false);
        };
        document.addEventListener("keydown", onKey);
        document.addEventListener("mousedown", onClick);
        return () => {
            document.removeEventListener("keydown", onKey);
            document.removeEventListener("mousedown", onClick);
        };
    }, [open]);

    return (
        <div className="mp-help" ref={rootRef}>
            <button
                type="button"
                className="mp-help-button"
                aria-label={`Что это: ${title}`}
                aria-expanded={open ? "true" : "false"}
                aria-controls={panelId}
                onClick={() => setOpen((value) => !value)}
            >
                ?
            </button>
            {open ? (
                <div className="mp-help-panel" id={panelId} role="dialog" aria-label={title}>
                    <h4 className="mp-help-title">{title}</h4>
                    <div className="mp-help-body">{children}</div>
                    <button type="button" className="mp-btn mp-btn-small" onClick={() => setOpen(false)}>
                        Понятно
                    </button>
                </div>
            ) : null}
        </div>
    );
}
